import { USED_COLLECTION_REQUEST } from '../types';

export const reqUsedCollectionAction = () => ({
  type: USED_COLLECTION_REQUEST
});

export default {
  reqUsedCollectionAction
};
